module.exports = __webpack_public_path__ + "img/AttachMoneyOutlined.deee0a1d.svg";